import styled from 'styled-components';

const ShopStyle = styled.div`
	--topBarMarginTop: var(--sp10x);
	--mainContentMarginTop: var(--sp8x);
	--mainContentMarginBottom: var(--sp8x);

	--productColWidth: calc(100% / 3);

	margin-top: var(--topBarMarginTop);

	.product-empty-text {
		width: 100%;
		margin-top: var(--gutter);
		padding-left: var(--colPadding);
	}

	.main-content-wrap {
		display: flex;
		margin-top: var(--mainContentMarginTop);
		margin-bottom: var(--mainContentMarginBottom);

		.items-listing {
			display: flex;
			flex-wrap: wrap;
			flex: 1;
			height: fit-content;
			margin-top: calc(var(--gutter) * -1);
			margin-left: calc(var(--colPadding) * -1);
			margin-right: calc(var(--colPadding) * -1);

			.product-col {
				width: var(--productColWidth);
				margin-top: var(--gutter);
				padding-left: var(--colPadding);
				padding-right: var(--colPadding);
			}
		}
	}

	.filters-wrap {
		position: relative;
		display: none;

		.filter-button {
			display: flex;
			align-items: center;
			justify-content: center;
			width: var(--sp22x);
			padding: var(--sp1x) var(--sp6x);
			background-color: var(--green);
			border-radius: var(--sp2-5x);
			cursor: pointer;

			.filter-icon {
				margin-right: var(--sp2x);
			}
		}

		.dropdown {
			position: absolute;
			top: 150%;
			left: 0;
			width: 100%;
			padding: 0 var(--sp3x);
			background-color: var(--white);
			border-radius: var(--sp3x);
			height: 0;
			overflow: hidden;
			z-index: 3;

			&.active {
				box-shadow: 0px 2px 6px #8d8d8d29;
				padding: var(--sp1x) var(--sp3x);
				height: fit-content;
			}
		}
	}

	@media only screen and (min-width: 2560px) {
		--productColWidth: calc(100% / 4);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--topBarMarginTop: var(--sp9x);
		--mainContentMarginTop: var(--sp6x);
		--mainContentMarginBottom: var(--sp6x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--topBarMarginTop: var(--sp8x);
		--mainContentMarginTop: var(--sp5x);
		--mainContentMarginBottom: var(--sp5x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--topBarMarginTop: var(--sp6x);
		--mainContentMarginTop: var(--sp5x);
		--mainContentMarginBottom: var(--sp5x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--topBarMarginTop: var(--sp5x);
		--mainContentMarginTop: var(--sp8x);
		--mainContentMarginBottom: var(--sp4x);

		.sort-by {
			width: var(--sp30x);
		}

		.filters-wrap {
			display: flex;
			justify-content: space-between;
			align-items: center;
		}

		.top-bar-wrapper {
			display: none;
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--topBarMarginTop: var(--sp5x);
		--mainContentMarginTop: var(--sp3x);
		--mainContentMarginBottom: var(--sp2-5x);

		--productColWidth: 50%;
		--colPadding: calc(var(--sp1x) / 2) !important;

		.sort-by {
			width: 45vw;

			.ant-select-single.ant-select-show-arrow .ant-select-selection-item {
				padding-right: 0;
				padding-inline-end: var(--sp3x);
			}
		}

		.filters-wrap {
			display: flex;
			justify-content: space-between;
			align-items: center;

			.filter-button {
				width: unset;
			}
		}

		.top-bar-wrapper {
			display: none;
		}
	}
`;

export default ShopStyle;
